<template>
  <div id="choice" class="d-flex min-height">
    <vue-headful title="De invalpool voor het basisonderwijs" />
    <header class="w-100">
      <div class="container-fluid px-4">
        <div class="icon-wrapper derect-logo">
          <svg-icon icon="derect_logo"></svg-icon>
          <span>Direct een extra kracht</span>
        </div>
        <p class="m-0 d-inline-block login">
          <router-link :to="{ name: 'login' }" title="Inloggen" class="text-brown">
            <svg-icon icon="person_male"></svg-icon> Inloggen
          </router-link>
        </p>
      </div>
    </header>
    <div class="py-5 px-4 container-fluid margin-unset">
      <div class="about-derect">
        <router-link :to="{ name: 'about' }">Over Derect</router-link>
      </div>
      <h2 class="sd-title bold white text-center large margin-bottom-2">
        Meld je aan bij Derect!
      </h2>
      <div class="sd-container bg-white">
        <h3 class="sd-title bold">
          <svg-icon icon="education" />
          Basis- en voortgezet onderwijs
        </h3>
        <div class="pt-4 margin-bottom-1">
          <router-link
              v-on:click.native.prevent="setBranchInLocalstorage($event, 1, 'applicant')"
              event=""
              to=""
              class="btn btn-warning button-yellow w-100 m-auto"
              v-ripple="'rgba(255, 193, 7, 0.35)'">
            Ik wil invallen
          </router-link>
        </div>
        <router-link
            v-on:click.native.prevent="setBranchInLocalstorage($event, 1, 'company')"
            event=""
            to=""
            class="btn btn-outline-warning m-auto w-100"
            v-ripple="'rgba(255, 193, 7, 0.35)'">
          Ik zoek een <span>invalkracht</span>
        </router-link>
      </div>
    </div>
    <footer class="position-fixed bg-white w-100">
      <p>
        Hulp nodig? Bel/Whatsapp ons: <a href="tel:0850481976">085 048 1976</a>
        <a v-if="isMobile()" href="https://wa.me/31850481976?text=HELP!"><img class="whatsapp-image" src="@/assets/whatsapp-square-brands.png" /></a>
        <a v-if="!isMobile()" href="https://web.whatsapp.com/send?phone=31850481976&text=HELP%21"><img class="whatsapp-image" src="@/assets/whatsapp-square-brands.png" /></a>
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      center: true,
      showPhoneNumber: false,
    };
  },
  methods: {
    needSomebody() {
      this.showPhoneNumber = true;
    },
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    setBranchInLocalstorage(event, branchNumber, userType) {
      localStorage.setItem('branch', branchNumber);

      if(userType === 'company')
        this.$router.push({ name: 'register-2' });
      else
        this.$router.push({ name: 'register-1' });
    }
  }
};
</script>

<style scoped>
.d-flex {
  flex-direction: column;
}

h3 {
  display: flex;
  align-items: center;
}

p {
  font: 14px/1 "Real Head Pro";
  font-weight: 200;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64513d;
}

p a {
  color: #64513d;
}

header {
  padding-top: 30px;
}

.about-derect {
  position: absolute;
  right: -32px;
  transform: rotate(-90deg);
}

.about-derect a {
  background-color: #64513D;
  color: #FFF;
  padding: 7px 12px;
  border-radius: 5px 5px 0 0;
  font-weight: 400;
}

.derect-logo span {
  display: block;
  font-size: 10px;
  font-weight: normal;
}

.button-yellow {
  width: 265px;
}

.pt-9 {
  padding-top: 9rem !important;
}

.margin-unset {
  margin-top: unset !important;
  margin-bottom: unset !important;
}

.margin-bottom-0 {
  margin-bottom: 0;
}

.margin-bottom-1 {
  margin-bottom: 1rem;
}

.margin-bottom-2 {
  margin-bottom: 2rem;
}

.btn-outline-warning {
  color: #64513d;
  font-weight: 200;
}

.btn-outline-warning span {
  font-weight: normal;
}

footer {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

footer img {
  width: 20px;
  margin-left: 10px;
}

@media screen and ( max-height: 600px ){
  .derect-how {
    margin: 0px;
  }

  .margin-bottom-3 {
    margin-bottom: 0;
  }

  .margin-bottom-1 {
    margin-bottom: 15px;
  }

  .button-yellow  {
    margin-bottom: 5px;
  }

  .text-yellow {
    margin-bottom: 0;
  }
}

</style>
